import env from './env'

function getDomain() {
  let domain
  if (env.applicationStage === 'development') {
    domain = env.domain
  } if (env.applicationStage === 'production' || env.applicationStage === 'staging') {
    domain = `//${window.location.hostname}`
  }

  return domain
}

export default getDomain
